import React from 'react';
import * as XLSX from 'xlsx';
import { extractNameAndSurname } from '../../utils/excelfunction';
import { niveauDe } from '../../utils/campagneEvalNat';
import { useMemo } from 'react';
import { Download } from 'lucide-react';
const ExportEvalNatGroupe = ({ resultats, AutomatismeQuestions, ProblèmesQuestions }) => {

function createSyntheseSheet(questions, testName) {
  const sortedQuestions = Object.entries(questions).sort(([keyA], [keyB]) => {
    const numA = parseInt(keyA.replace('Q', ''), 10); // Extraire le numéro, ex : "Q1" -> 1
    const numB = parseInt(keyB.replace('Q', ''), 10); // Ex : "Q10" -> 10
    return numA - numB; // Trier par numéro croissant
  });
  
  
  // Ajout du titre et des en-têtes
  const title = [["Évaluations nationales : Test spécifique en " + testName, "", ""]];
  const headers = [["N°", "Savoir-Faire", "% réussite"]];

  // Définir l'index de départ pour les colonnes
  const startIndex = 5; // F correspond à l'index 5

  // Parcourir les questions
    // Parcourir les questions triées
    const data = sortedQuestions.map(([key, description], index) => {
      const colIndex = startIndex + index * 2; // Sauter une colonne entre chaque question
      const colLetter = XLSX.utils.encode_col(colIndex); // Convertir l'index en lettre Excel
  
      return [
        key, // Numéro de la question
        description || 'Description manquante', // Description
        { // Formule Excel pour le pourcentage de réussite
          t: 'n',
          f: `${testName}!${colLetter}3`,
        },
      ];
    });

    // Créer une feuille Excel pour les données principales
    const worksheet = XLSX.utils.aoa_to_sheet([...title, [], ...headers, ...data]);
  
    // Ajouter le tableau "Mastery Group Distribution" à partir de G3
    const masteryHeaders = [['Groupe', 'Nombre', 'Pourcentage']];

    let masteryData  =[]
   
    niveauDe(resultats) === '6' ?
     masteryData = [
      [
        'À besoins',
        { t: 'n', f: `COUNTIF(${testName}!D4:D5000,"${testName === "Resultats.Automatisme" ? "<7" : "<5"}")` },
        { t: 'n', f: `IF(H4=0,"",H4/COUNTA(${testName}!D4:D5000))` },
      ],
      [
        'Fragile',
        { t: 'n', f: `COUNTA(${testName}!D4:D5000) - H4 - H6` },
        { t: 'n', f: `IF(H5=0,"",H5/COUNTA(${testName}!D4:D5000))` },
      ],
      [
        'Satisfaisant',
        { t: 'n', f: `COUNTIF(${testName}!D4:D5000,"${testName === "Resultats.Automatisme" ? ">12" : ">9"}")` },
        { t: 'n', f: `IF(H6=0,"",H6/COUNTA(${testName}!D4:D5000))` },
      ],
    ]
    :
    masteryData = [
      [
        'À besoins',
        { t: 'n', f: `COUNTIF(${testName}!D4:D5000,"${testName === "Resultats.Automatisme" ? "<8" : "<5"}")` },
        { t: 'n', f: `IF(H4=0,"",H4/COUNTA(${testName}!D4:D5000))` },
      ],
      [
        'Fragile',
        { t: 'n', f: `COUNTA(${testName}!D4:D5000) - H4 - H6` },
        { t: 'n', f: `IF(H5=0,"",H5/COUNTA(${testName}!D4:D5000))` },
      ],
      [
        'Satisfaisant',
        { t: 'n', f: `COUNTIF(${testName}!D4:D5000,"${testName === "Resultats.Automatisme" ? ">12" : ">10"}")` },
        { t: 'n', f: `IF(H6=0,"",H6/COUNTA(${testName}!D4:D5000))` },
      ],
    ]
    ;
  
    // Ajouter les en-têtes et données du tableau de maîtrise à partir de G3
    XLSX.utils.sheet_add_aoa(worksheet, masteryHeaders, { origin: 'G3' });
    XLSX.utils.sheet_add_aoa(worksheet, masteryData, { origin: 'G4' });
  
    return worksheet;
  }
const labelAutomatismes = useMemo(() => {
  
  return resultats.questions
    .filter(question => question.type_label === "Automatisme")
    .reduce((acc, question) => {
      acc[question.question_num] = question.nom_label;
      return acc;
    }, {});
}, [resultats]); // Les dépendances sont les questions de EvalNat

const labelProblèmes = useMemo(() => {

  return resultats.questions
    .filter(question => question.type_label === "Résolution de problèmes")
    .reduce((acc, question) => {
      acc[question.question_num] = question.nom_label;
      return acc;
    }, {});
}, [resultats]); // Les dépendances sont les questions de EvalNat



  const handleExport = () => {
    const globalHeaders = [
      'Classe',
      'Nom',
      'Prénom',
      'Automatisme',
      'Probleme',
      'EEG',
      'NEC',
      'GEM',
      'OGD'
    ];


    const dataForSheets = resultats.eleves_reponses.map((item) => {
        // Extraction du nom et prénom depuis 'nom_eleve'
    const { nom, prenom } = extractNameAndSurname(item.nom_eleve);

    return {
      Classe: item.classe_nom,
      Nom: nom || 'N/A',
      Prénom: prenom || 'N/A',
      Automatisme: item.reponses.Automatisme,
      Probleme: item.reponses.Probleme,
      EEG: item.reponses['EEG'],
      NEC: item.reponses['NEC'],
      GEM: item.reponses['GEM'],
      OGD: item.reponses['OGD'] || 'N/A'

    }
    });
    function createSheetData(resultats, typeScoreSpecifique, testType, questionCount) {
      return resultats.map((item) => {
        const { nom, prenom } = extractNameAndSurname(item.nom_eleve);
    
        const row = {
          Classe: item.classe_nom || 'N/A',
          Nom: nom || 'N/A',
          Prénom: prenom || 'N/A',
          [`Score du test spécifique ${typeScoreSpecifique}`]: item.reponses[`Score du test spécifique ${typeScoreSpecifique}`] || 0,
        };
    
        // Ajout dynamique des colonnes pour chaque question
        for (let i = 1; i <= questionCount; i++) {
          row[`${testType} Q${i} réponse`] = item.reponses[testType]?.[`Q${i}`]?.réponse || 'N/A';
          row[`${testType} Q${i} score`] = item.reponses[testType]?.[`Q${i}`]?.score || 0;
        }
    
        return row;
      });
    }
    
    function createSummaryRows(resultats,typeScoreSpecifique, testType, questionCount) {
      const nbBonnesReponsesRow = { Classe: '', Nom: 'Nb bonnes réponses', Prénom: '', [`Score du test spécifique ${typeScoreSpecifique}`]: '' };
      const percentBonnesReponsesRow = { Classe: '', Nom: '% de bonnes réponses', Prénom: '', [`Score du test spécifique ${typeScoreSpecifique}`]: '' };
    
      let baseIndex = 3; // Index initial pour commencer après les colonnes fixes (Classe, Nom, etc.)

      for (let i = 1; i <= questionCount; i++) {
        const colLetter = XLSX.utils.encode_col(baseIndex + i *2 ); // Convertir l'index en lettre (3 pour Classe, Nom, Prénom)
    
        nbBonnesReponsesRow[`${testType} Q${i} réponse`] = '';
        nbBonnesReponsesRow[`${testType} Q${i} score`] = { t: 'n', f: `COUNTIF(${colLetter}4:${colLetter}${resultats.length + 3},"1")` };
    
        percentBonnesReponsesRow[`${testType} Q${i} réponse`] = '';
        percentBonnesReponsesRow[`${testType} Q${i} score`] = {
          t: 'n',
          f: `IF(COUNTA(${colLetter}4:${colLetter}${resultats.length + 3})=0,"",COUNTIF(${colLetter}4:${colLetter}${resultats.length + 3},"1")/COUNTA(${colLetter}4:${colLetter}${resultats.length + 3})) * 100`,
        };
      }

     
    
      return [nbBonnesReponsesRow, percentBonnesReponsesRow];
    }
    
    // Générer les feuilles
    const automatismeSheetData = createSheetData(resultats.eleves_reponses, 'automatisme','Automatismes', resultats.eleves_reponses[0]?.classe_nom[0] === '6' ? 23 : 22);
    const problemeSheetData = createSheetData(resultats.eleves_reponses, 'problème', 'Problèmes', 19);
    
    const automatismeSummary = createSummaryRows(resultats.eleves_reponses, 'automatisme', 'Automatismes', resultats.eleves_reponses[0]?.classe_nom[0] === '6' ? 23 : 22);
    const problemeSummary = createSummaryRows(resultats.eleves_reponses, 'problème', 'Problèmes', 19);
    
    const finalAutomatismeData = [...automatismeSummary, ...automatismeSheetData];
    const finalProblemeData = [...problemeSummary, ...problemeSheetData];
    
    // Création des feuilles Excel
    const workbook = XLSX.utils.book_new();
    
    const globalSheet = XLSX.utils.json_to_sheet(dataForSheets, { header: globalHeaders });
    XLSX.utils.book_append_sheet(workbook, globalSheet, 'Résultats Globaux');
    
    const automatismeExcelSheet = XLSX.utils.json_to_sheet(finalAutomatismeData);
    XLSX.utils.book_append_sheet(workbook, automatismeExcelSheet, 'Resultats.Automatisme');
    
    const problemeExcelSheet = XLSX.utils.json_to_sheet(finalProblemeData);
    XLSX.utils.book_append_sheet(workbook, problemeExcelSheet, 'Resultats.ResdeProb');
    // Utilisation de la fonction pour créer la feuille Synthese.Automatisme
  const syntheseAutSheet = createSyntheseSheet(
  labelAutomatismes,
    'Resultats.Automatisme'
  );
  const synthesePbSheet = createSyntheseSheet(
    labelProblèmes,
      'Resultats.ResdeProb'
    );
  XLSX.utils.book_append_sheet(workbook, syntheseAutSheet, 'Synthese.Automatisme');
  XLSX.utils.book_append_sheet(workbook, synthesePbSheet, 'Synthese.Problème');
    // Forcer le recalcul des formules
    workbook.Workbook = {
      Views: [{ CalcPr: { calcId: 1 } }],
    };
    const fileName = 'Evaluation_Results.xlsx'
    XLSX.writeFile(workbook, fileName);
   
  
    
  }

    

  return (
    <button
      onClick={handleExport}
      className="flex items-center gap-2 px-3 py-1.5 bg-white text-emerald-600 rounded-lg border border-emerald-200 text-xs font-semibold hover:bg-emerald-50 hover:border-emerald-300 hover:shadow-md transition-all duration-200 cursor-pointer"
    >
      <Download className="w-3.5 h-3.5" />
      <span>Export .xlsx</span>
    </button>
  );
};

export default ExportEvalNatGroupe;